<template>
  <a-drawer
    :title="title"
    :maskClosable="true"
    :width="700"
    placement="right"
    :closable="true"
    @close="handleCancel"
    :visible="visible"
    style="overflow: auto; padding-bottom: 53px"
  >
    <a-spin :spinning="confirmLoading">
      <a-form :form="form">
        <a-form-item
          label="消息内容"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-textarea
            :rows="4"
            placeholder="消息内容"
            v-decorator="[
              'document',
              {
                rules: [
                  {
                    required:
                      this.form.getFieldValue('type') == 0 ? true : false,
                    message: '请输入消息内容！',
                  },
                ],
              },
            ]"
          />
        </a-form-item>
        <a-form-item
          label="素材类型"
          :labelCol="labelCol"
          :wrapperCol="wrapperCol"
        >
          <a-radio-group name="radioGroup" v-decorator="['type']">
            <a-radio value="0"> 无 </a-radio>
            <a-radio value="1"> 图片 </a-radio>
            <a-radio value="2"> 链接 </a-radio>
            <a-radio value="3"> 小程序 </a-radio>
          </a-radio-group>
        </a-form-item>
        <div style="margin-top: 20px">
          <a-form-item
            v-show="this.form.getFieldValue('type') == 1"
            label="图片"
            :labelCol="labelCol"
            :wrapperCol="wrapperCol"
          >
            <UploadImage
              :accept="'.jpg, .png'"
              :imgUrl="fileList.fileUrl"
              @handleFileList="
                (e) => {
                  getFileList(e, 'imgpicurl');
                }
              "
              v-decorator="[
                'imgpicurl',
                {
                  required: this.form.getFieldValue('type') == 1 ? true : false,
                  message: '请上传图片!',
                },
              ]"
            />
          </a-form-item>
          <div v-show="this.form.getFieldValue('type') == 2">
            <a-form-item
              label="链接地址"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                placeholder="请输入链接地址,以http://或https://开头"
                v-decorator="[
                  'linkurl',
                  {
                    rules: [
                      {
                        required:
                          this.form.getFieldValue('type') == 2 ? true : false,
                        message: '请输入链接地址',
                      },
                    ],
                  },
                ]"
              />
              <!-- { required: true, message: '请输入链接地址!' } -->
            </a-form-item>
            <a-form-item
              label="图文标题"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                placeholder="请输入图文标题"
                v-decorator="[
                  'linktitle',
                  {
                    rules: [
                      {
                        required:
                          this.form.getFieldValue('type') == 2 ? true : false,
                        message: '请输入链接地址',
                      },
                    ],
                  },
                ]"
              />
              <!-- { required: true, message: '请输入图文标题!' } -->
            </a-form-item>
            <a-form-item
              label="图文封面"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <!-- <j-image-upload
                file-type="file"
                accept=".jpg, .png"
                text="上传"
                fileKey="picFile"
                v-decorator="['linkpicurl']"
                url="/wechatwork-groupchat-biz/wechatwork/wechatMsg/upMaterial"
              >
              </j-image-upload> -->
              <UploadImage
                :accept="'.jpg, .png'"
                :imgUrl="fileList.fileUrl"
                @handleFileList="
                  (e) => {
                    getFileList(e, 'linkpicurl');
                  }
                "
                v-decorator="['linkpicurl']"
              />
            </a-form-item>
            <a-form-item
              label="图文描述"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-textarea
                :rows="4"
                placeholder="请输入图文描述"
                v-decorator="['linkdesc']"
              />
            </a-form-item>
          </div>
          <div v-show="this.form.getFieldValue('type') == 3">
            <a-form-item
              label="appid"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                placeholder="请输入appid"
                v-decorator="[
                  'miniappid',
                  {
                    rules: [
                      {
                        required:
                          this.form.getFieldValue('type') == 3 ? true : false,
                        message: '请输入appid!',
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
            <a-form-item
              label="小程序消息标题"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                placeholder="请输入小程序消息标题"
                v-decorator="[
                  'minititle',
                  {
                    rules: [
                      {
                        required:
                          this.form.getFieldValue('type') == 3 ? true : false,
                        message: '请输入小程序消息标题!',
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
            <a-form-item
              label="小程序消息封面"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <UploadImage
                :accept="'.jpg, .png'"
                :imgUrl="fileList.fileUrl"
                @handleFileList="
                  (e) => {
                    getFileList(e, 'minipicmediaid');
                  }
                "
                v-decorator="[
                  'minipicmediaid',
                  {
                    required:
                      this.form.getFieldValue('type') == 3 ? true : false,
                    message: '请输入小程序消息封面!',
                  },
                ]"
              />
            </a-form-item>
            <a-form-item
              label="页面路径"
              :labelCol="labelCol"
              :wrapperCol="wrapperCol"
            >
              <a-input
                placeholder="请输入页面路径"
                v-decorator="[
                  'minipage',
                  {
                    rules: [
                      {
                        required:
                          this.form.getFieldValue('type') == 3 ? true : false,
                        message: '请输入页面路径!',
                      },
                    ],
                  },
                ]"
              />
            </a-form-item>
          </div>
        </div>
      </a-form>
    </a-spin>
    <div class="drawer-bootom-button" v-show="!disableSubmit">
      <a-popconfirm
        title="确定放弃编辑？"
        @confirm="handleCancel"
        okText="确定"
        cancelText="取消"
      >
        <a-button style="margin-right: 0.8rem">取消</a-button>
      </a-popconfirm>
      <a-button @click="handleSubmit" type="primary" :loading="confirmLoading"
        >提交审核</a-button
      >
    </div>
  </a-drawer>
</template>

<script>
import pick from 'lodash.pick';
import moment from 'moment';
import { postTag } from '@/api/manage';
import { getFileIOByMediaId } from '@/api/api';
import UploadImage from '@/components/common/UploadImage';

export default {
  name: 'TextingMoadl',
  components: {
    UploadImage,
  },
  data() {
    return {
      id: '',
      editType: false,
      modalWidth: 800,
      modaltoggleFlag: true,
      disableSubmit: false,
      title: '操作',
      visible: false,
      value: null,
      model: {},
      labelCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 5,
        },
      },
      wrapperCol: {
        xs: {
          span: 24,
        },
        sm: {
          span: 16,
        },
      },
      confirmLoading: false,
      headers: {},
      form: this.$form.createForm(this),
      url: {
        fileUpload: 'wechatwork-groupchat-biz/wechatwork/wechatMsg/upMaterial',
        formatParameter:
          process.env.VUE_APP_CMS_GROUPCHAT +
          '/wechatwork/wechatMsg/formatParameter',
        add:
          process.env.VUE_APP_CMS_GROUPCHAT +
          '/wechatwork/wechatMsg/upMaterialInfo',
        edit:
          process.env.VUE_APP_CMS_GROUPCHAT +
          '/wechatwork/wechatMsg/editMaterial',
      },
      avatarUrl: '', //图片地址
      avatar_mediaid: '', //图片的id
      imageUrl: '',
      imgUploadUrl:
        process.env.VUE_APP_GATEWAY_URL +
        'wechatwork-groupchat-biz/wechatwork/wechatMsg/upFile',
      imageType:
        'image/jpg,image/png,image/jpeg,image/bmp,image/gif,image/webp',
      fileList: {},
    };
  },
  methods: {
    add(record) {
      this.edit(record || { type: 0 });
    },
    edit(record) {
      this.form.resetFields();
      this.visible = true;
      this.model = Object.assign({}, record);
      if (record.id) {
        this.editType = true;
        this.id = record.id;
      }
      console.log(this.model);
      this.$nextTick(() => {
        setTimeout(() => {
          this.form.setFieldsValue(
            pick(
              this.model,
              'document',
              'type',
              'imgpicurl',
              'linkurl',
              'linktitle',
              'linkpicurl',
              'linkdesc',
              'miniappid',
              'minititle',
              'minipage'
            )
          );
          this.fileList = {
            fileName:
              this.model.type == 1
                ? this.model.imgpicurl
                : this.model.type == 2
                ? this.model.linkpicurl
                : this.model.miniappid,
            fileUrl: this.model.minipicmediaid,
          };
          console.log(this.fileList);

          this.form.setFieldsValue({
            minipicmediaid: this.model.minipicmediaid,
          });
        });
      }, 1000);
    },
    close() {
      this.$emit('close');
      this.visible = false;
    },
    moment,
    handleSubmit() {
      // 触发表单验证
      this.form.validateFields((err, values) => {
        if (!err) {
          let formData = '';
          debugger;
          console.log(values);
          if (values.type == '') {
            formData = {
              id: this.id,
              type: parseInt(values.type),
              // type: values.type,
              document: values.document,
            };
          } else if (values.type == '1') {
            formData = {
              document: values.document,
              imgpicurl: this.fileList.fileName, //values.imgpicurl,
              id: this.id,
              type: parseInt(values.type),
            };
          } else {
            formData = {
              document: values.document,
              linktitle: values.linktitle,
              linkpicurl: this.fileList.fileName, //values.linkpicurl,
              linkdesc: values.linkdesc,
              linkurl: values.linkurl,
              minititle: values.minititle,
              minipicmediaid: values.minipicmediaid,
              miniappid: values.miniappid,
              minipage: values.minipage,
              id: this.id,
              type: parseInt(values.type),
              // type: values.type
            };
            if (values.type == 3) {
              formData.programUrl = this.avatarUrl;
              formData.minipicmediaid = this.fileList.fileName; //this.avatar_mediaid;
            }
          }
          let url = '';
          if (!this.model.id) {
            // 新增
            url = this.url.add;
          } else {
            // 编辑
            url = this.url.edit;
          }
          postTag(url, formData).then((res) => {
            if (res.success) {
              this.$message.success(
                this.model.id ? '编辑成功！' : '新增成功！'
              );
              this.$emit('ok');
              this.close();
            } else {
              this.$message.error(res.msg);
            }
          });
        }
      });
    },

    handleCancel() {
      this.close();
    },
    getFileList(file, key) {
      this.fileList = file;
      this.form.setFieldsValue({
        [key]: process.env.VUE_APP_FILE_PATH + file.fileName,
      });
      console.log(file, key);
    },
  },
};
</script>

<style scoped>
.avatar-uploader > .ant-upload {
  width: 104px;
  height: 104px;
}

.ant-upload-select-picture-card i {
  font-size: 32px;
  color: #999;
}

.ant-upload-select-picture-card .ant-upload-text {
  margin-top: 8px;
  color: #666;
}

.ant-table-tbody .ant-table-row td {
  padding-top: 10px;
  padding-bottom: 10px;
}

.drawer-bootom-button {
  position: absolute;
  bottom: -8px;
  width: 100%;
  border-top: 1px solid #e8e8e8;
  padding: 10px 16px;
  text-align: right;
  left: 0;
  background: #fff;
  border-radius: 0 0 2px 2px;
}
</style>
